module.exports = __webpack_public_path__ + "img/3.f6ef9a97.svg";